import React from 'react';

import { Box, Text } from '@components/Restyle';
import Icon from '@components/shared/Icon/Icon';

type MembersTableHeaderProps = {
  isSortName: boolean;
  isSortNameAsc: boolean;
  onSortToggle: (isAscending: boolean) => void;
  showDeleteColumn?: boolean;
};

export const MembersTableHeader: React.FC<MembersTableHeaderProps> = ({
  isSortName,
  isSortNameAsc,
  onSortToggle,
  showDeleteColumn = false,
}) => {
  return (
    <Box
      flexDirection='row'
      backgroundColor='grey01'
      paddingVertical='s'
      paddingHorizontal='m'
      borderBottomWidth={1}
      borderBottomColor='grey02'>
      <Box flex={2.4} flexDirection='row' alignItems='center'>
        <Text variant='webBodySecondary' color='grey04'>
          Name
        </Text>
        <Icon
          marginLeft='xs'
          variant='xxs'
          name='ArrowUpNarrow'
          color={isSortName && isSortNameAsc ? 'greenSecondary' : 'grey04'}
          style={{ marginRight: -3 }}
          onPress={() => onSortToggle(true)}
        />
        <Icon
          variant='xxs'
          name='ArrowDownNarrow'
          color={isSortName && !isSortNameAsc ? 'greenSecondary' : 'grey04'}
          style={{ marginLeft: -3 }}
          onPress={() => onSortToggle(false)}
        />
      </Box>
      <Box flex={2.4} justifyContent='center' mx='m'>
        <Text variant='webBodySecondary' color='grey04'>
          Skills
        </Text>
      </Box>
      <Box flex={2} flexDirection='row' justifyContent='flex-start' mr='s'>
        <Text variant='webBodySecondary' color='grey04'>
          Email
        </Text>
      </Box>
      <Box flex={1.98} justifyContent='center' alignItems='flex-end' mx='m'>
        <Text variant='webBodySecondary' color='grey04'>
          Phone
        </Text>
      </Box>
      <Box
        ml='m'
        flex={1.4}
        flexDirection='row'
        alignItems='center'
        paddingLeft='l'
        justifyContent='flex-start'>
        <Text variant='webBodySecondary' color='grey04'>
          Role
        </Text>
      </Box>
      {/* Chat column spacer */}
      <Box flex={0.64} alignItems='center' justifyContent='center' />
      {/* Delete column spacer — matches the trash icon column in the member row */}
      {showDeleteColumn && (
        <Box flex={0.64} alignItems='center' justifyContent='center' />
      )}
    </Box>
  );
};
